import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 9.333a2.67 2.67 0 0 0-2.053.987l-3.4-1.567c.16-.49.16-1.017 0-1.506l3.4-1.567a2.667 2.667 0 1 0-.567-1.207l-3.52 1.62a2.667 2.667 0 1 0 0 3.814l3.52 1.62a3 3 0 0 0-.047.473A2.667 2.667 0 1 0 12 9.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })